import { render, staticRenderFns } from "./S5.vue?vue&type=template&id=5fe0119e&scoped=true&"
import script from "./S5.vue?vue&type=script&lang=js&"
export * from "./S5.vue?vue&type=script&lang=js&"
import style0 from "./S5.vue?vue&type=style&index=0&id=5fe0119e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe0119e",
  null
  
)

component.options.__file = "S5.vue"
export default component.exports